var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9003 0.34494H8.0997C3.62636 0.34494 0 4.04488 0 8.60898V27.791C0 32.3551 3.62636 36.0551 8.0997 36.0551H26.9003C31.3736 36.0551 35 32.3551 35 27.791V8.60898C35 4.04488 31.3736 0.34494 26.9003 0.34494Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1771 12.7028C27.7291 11.2965 26.2465 10.4445 24.8822 10.2488C19.9745 9.71671 15.0262 9.71671 10.1185 10.2488C8.75423 10.4438 7.26743 11.288 6.82363 12.7028C6.12503 16.3338 6.12503 20.0691 6.82363 23.7001C7.27163 25.1049 8.75423 25.9584 10.1185 26.1541C15.0262 26.6862 19.9745 26.6862 24.8822 26.1541C26.2465 25.9591 27.7333 25.1149 28.1771 23.7001C28.8757 20.0691 28.8757 16.3338 28.1771 12.7028ZM14.8204 22.5802V13.8205L21.8092 18.2C19.453 19.677 17.1661 21.109 14.8204 22.5795V22.5802Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35.7101,
    fill: "white",
    transform: "translate(0 0.34494)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.da9e1fea1212b2f10584b421c799f770.svg";
export { ForwardRef as ReactComponent };